export default "__VITE_ASSET__D201J5AN__"